import { NetworkResponse } from "~/app/type/common";
import { requestREST } from "~/client/http/CommonHTTP";
import { TemplateFieldsIProps, TemplateIProps } from "../model/schema";

const templateServiceMap = {
  getList: "/contract/tmps/list",
  getFields: "/contract/tmps/fields",
  getById: "/contract/tmps/",
  delete: "/contract/tmps/",
  create: "/contract/tmps/",
};

export class Template {
  static GET = {
    getList: (): NetworkResponse<TemplateIProps[]> =>
      requestREST.get(templateServiceMap.getList),
    getTemplateById: (id: string): NetworkResponse<TemplateIProps> =>
      requestREST.get(templateServiceMap.getById + id),
    getTemplateFields: (): NetworkResponse<TemplateFieldsIProps> =>
      requestREST.get(templateServiceMap.getFields),
  };
  static POST = {};
  static DELETE = {};
}
